
{
  "en": {
    "Now you can read reports from lunches you've had!": "Now you can read reports from lunches you've had!"
  },
  "ja": {
    "Now you can read reports from lunches you've had!": "参加したGIPランチのレポートを確認できるようになりました！"
  }
}
